import React, {Component} from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import {Formik, Field, FieldArray} from 'formik';
import _ from 'lodash';
import config from '../config';
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {SchedulePicker} from "../components/schedule-picker"
import {Cohorts} from "../components/Cohorts";

export default class Event extends Component {
    static contextType = AuthContext

    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {id} = this.props.match.params;
        this.state = {
            id,
            obj: null
        };
        this.init = this.init.bind(this);
        this.save = this.save.bind(this);
        this.init(id);
    }

    async init(id) {
        let responseCohorts = await fetcher(`${config.API()}collection/cohorts`);
        this.cohorts = await responseCohorts.json();
        let responseEvents = await fetcher(`${config.API()}collection/events`);
        let events = await responseEvents.json();

        let responseContests = await fetcher(`${config.API()}collection/contests`);
        let contests = await responseContests.json();

        if (id == "new") {
            this.setState({
                obj: {
                    _id: "new",
                    rewards: {}
                },
                events : [].concat(events).concat(contests),

            })
        } else {
            let responseN = await fetcher(`${config.API()}collection/notifications`);
            let notifications = await responseN.json();
            let obj = _.find(notifications, x => x._id == id)
            if(!obj.rewards)
                obj.rewards = {};
            this.setState({obj,  events : [].concat(events).concat(contests),})
        }
    }

    async save(values) {
        if (values.timeType === 'daterange') {
            delete values.weekly;
        }

        if (values.timeType === 'weekly') {
            delete values.dateRanges;
        }

        var body = JSON.stringify(values);
        fetcher(`${config.API()}collection/notifications/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body
        })
            .then(response => response.json())
            .then(data => {
                this.setState({redirect: `/notifications`});
            });
    }

    timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }
        return (
            <div>
                {this.state.obj && <Formik initialValues={this.state.obj} onSubmit={this.save}>
                    {({
                          values,
                          handleSubmit,
                          handleChange,
                          setFieldValue,
                          myHandleChange = evt => {
                              if(evt.target.type == "number" && evt.target.value == "")
                                  evt.target.value = 0;
                              handleChange(evt);
                          },
                          isSubmitting
                      }) => (
                        <div className="card shadow w100">
                            <div className="card-header py-3">
                                <h2 className="m-0 font-weight-bold l">Notification <span className="text-primary">{values.title}</span></h2>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {values._id != "new" && <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Id</label>
                                        <div className="col-sm-10">
                                            {values._id}
                                            <input className="form-control" type="hidden" name="_id" onChange={myHandleChange} value={values._id}/>
                                        </div>
                                    </div>}
                                    <div className="form-group row">
                                        <label className="col-sm-2 col-form-label">Title</label>
                                        <div className="col-sm-10">
                                            <input className="form-control" type="text" name="title" onChange={myHandleChange} value={values.title}/>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-md-2 col-sm-4 col-form-label">Text</label>
                                        <div className="col-md-10 col-sm-8">
                                            <input type="text"
                                                   name="text"
                                                   className="form-control"
                                                   onChange={myHandleChange}
                                                   value={values.text}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-md-2 col-sm-4 col-form-label">Image</label>
                                        <div className="col-md-10 col-sm-8">
                                            <input type="text" name="image" className="form-control" onChange={myHandleChange} value={values.image}/>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label className="col-md-2 col-sm-4 col-form-label">Trigger</label>
                                        <div className="col-md-10 col-sm-8">
                                            <select name="trigger" className="form-control"
                                                    value={values.trigger}
                                                    onChange={myHandleChange}>
                                                <option value="">None</option>
                                                <option value="OnStartEvent">OnStartEvent</option>
                                                <option value="OnEndEvent">OnEndEvent</option>
                                                <option value="SendOnStart">SendOnStart</option>
                                            </select>
                                        </div>
                                    </div>

                                    {["OnStartEvent", "OnEndEvent"].includes(values.trigger) && <div>
                                        <div className="form-group row">
                                            <label className="col-md-2 col-sm-4 col-form-label">OnEvent</label>
                                            <div className="col-md-10 col-sm-8">
                                                <select name="eventId" className="form-control"
                                                        value={values.eventId}
                                                        onChange={evt => {
                                                            let event = _.find(this.state.events, x => x._id == evt.target.value);
                                                            if (event)
                                                                setFieldValue(`cohortIds`, event.cohortIds)

                                                            myHandleChange(evt);
                                                        }}>
                                                    <option value="">None</option>
                                                    {_.values(this.state.events).map((x, i) =>
                                                        <option value={x._id} key={`nStartEvent-${x._id}`}>{x.title}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <label className="col-md-2 col-sm-4 col-form-label">Event cohorts: </label>
                                            <div className="col-5">
                                                {this.cohorts && this.cohorts.map(s =>
                                                    <div>{values.cohortIds && values.cohortIds.includes(s._id) && <span>{s.title}</span>}</div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-md-2 col-sm-4 col-form-label">Offset (sec)</label>
                                            <div className="col-md-10 col-sm-8">
                                                <input type="number" name="offset" className="form-control" onChange={myHandleChange} value={values.offset || ""}/>
                                            </div>
                                        </div>
                                    </div>

                                    }

                                    <div className="form-group row">
                                        <label className="col-md-2 col-sm-4 col-form-label">TelegramGroupId</label>
                                        <div className="col-md-10 col-sm-8">
                                            <input type="text" name="tgGroupId" className="form-control" onChange={myHandleChange} value={values.tgGroupId}/>
                                        </div>
                                    </div>

                                    {!["OnStartEvent", "OnEndEvent"].includes(values.trigger) && !values.tgGroupId &&
                                        <Cohorts name="cohortIds" cohorts={this.cohorts} cohortIds={values.cohortIds} setFieldValue={setFieldValue}/>
                                    }

                                    <SchedulePicker values={values} handleChange={handleChange} handleChangeState={(item) => this.setState({item})}/>
                                    <button type="submit" className="btn btn-icon btn-success ml-1 r mt-3"><span className="fas fa-fw fa-save"></span>Save</button>
                                </form>
                            </div>
                        </div>
                    )}
                </Formik>}
            </div>
        );
    }
}